import { RightSizingRecommendation } from "../../../../../services/cloudchipr.api";
import { RootState } from "../../../../store";
import { rightsizingDismissedRecommendationsSelector } from "../rightsizingRecommendationsSelector";

export const rightsizingRecommendationsDismissedDataSelector = (
  state: RootState,
): RightSizingRecommendation[] | undefined => {
  return rightsizingDismissedRecommendationsSelector(state)?.data;
};
